module.exports = __webpack_public_path__ + "static/media/avenir-next.b5ed9330.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir-next.otf
// module id = 1027
// module chunks = 3